import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import imageCompression from 'browser-image-compression';

import IOSSwitch from "./IOSSwitch";
import { insertDataJson, updateItem } from "../../Tools/helpers";
import { PDFDownloadLink } from "@react-pdf/renderer";

import PaymentCard from "./PaymentCard";
import PaymentTransfer from "./PaymentTransfer";
import PDFReceipt from "../../Tools/PDFReceipt";
import PaymentOnline from "./PaymentOnline";
import MercadoPagoButton from "./MercadoPagoButton";

const PaymentCashModule = ({ infoPayment, setInfoPayment, refreshList, studentData }) => {
  const [isBilled, setIsBilled] = useState(false);
  const [userData] = useState(JSON.parse(localStorage.getItem("USER_IUMV")));
  const [isPaidStatus, setIsPaidStatus] = useState(false);
  const [metodoPago, setMetodoPago] = useState('transfer');
  const [infoReceipt, setInfoReceipt] = useState({});
  const [infoBill, setInfoBill] = useState({
    business_name: "",
    rfc: "",
    cfdi: "",
    bill: "",
  });

  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const setState = (e) => {
    setInfoBill({
      ...infoBill,
      [e.target.name]: e.target.value,
    });
  };

  const handleFile = async (event) => {
    setMessage({
      status: true,
      message: "Comprimiendo...",
    });
    const imageFile = event.target.files[0];
    console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
    console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);
  
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    }
    try {
      const compressedFile = await imageCompression(imageFile, options);
      console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
      console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
      console.log(compressedFile);

      const reader = new FileReader();
      reader.readAsDataURL(compressedFile); 
      reader.onloadend = function() {
        const imgBase64data = reader.result;                
        console.log(imgBase64data);
        setInfoPayment({
          ...infoPayment,
          evidence: imgBase64data,
        });
        setMessage({
          status: false,
          message: "",
        });
    }

    } catch (error) {
      console.log(error);
    }
  }

  const handleFile_ = (event) => {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    const maxSizeFile = event.target.files[0].size;
    setMessage({
      status: false,
      message: "",
    });
    if (maxSizeFile > 3000000) {
      setMessage({
        status: true,
        label: "error",
        message: "El archivo debe pesar menos de 3M",
      });
      return;
    }
    reader.onload = function () {
      console.log(reader.result);
      setInfoPayment({
        ...infoPayment,
        evidence: reader.result,
      });
    };
  };

  const PaymentMercadoPago = async () => {
    const route = "crear-preferencia-pago";
    const send = await insertDataJson(route, infoPayment);
    
    if (send.status === 'error') {
      if(send.errors){
        setMessage({
          status: true,
          label: "error",
          message: send.errors,
        });
        return;        
      }
      setMessage({
        status: true,
        label: "error",
        message: "No se realizó la transacción",
      });
      return;
    }
    openPaymentPopup(send.data.init_point);
  };

  const openPaymentPopup = (url) => {
    //return;
    window.location.href = url;
    return;

    // const width = window.innerWidth;
    // const height = 400;
    // const left = window.innerWidth / 2 - width / 2;
    // const top = window.innerHeight / 2 - height / 2;

    // const popupWindow = window.open(
    //   url, 
    //   'Pago en Mercado Pago',
    //   `width=${width},height=${height},left=${left},top=${top}`
    // );
  }

  useEffect(() => {
    if (infoPayment.paid_status === "paid" || infoPayment.paid_status === "surchargePaid") {
      setIsPaidStatus(true);
    } else {
      setIsPaidStatus(false);
    }

    // if (infoPayment.you_can_pay === "false") {
    //   setMessage({
    //     status: true,
    //     message: "Debe pagar primero los meses anteriores",
    //     label: "warning",
    //   });
    // } else if (infoPayment.you_can_pay === "true") {
    //   setMessage({
    //     status: false,
    //     message: "",
    //     label: "",
    //   });
    // }

  }, [infoPayment]);

  const savePaymentStudent = async (action) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    if(infoPayment.amount === "" || Number(infoPayment.amount) === 0){
      setMessage({
        status: true,
        message: "Capture un monto válido",
        label: "error",
      });
      return;
    }

    if (
      isBilled &&
      (infoBill.length === 0 ||
        infoBill.business_name === "" ||
        infoBill.rfc === "" ||
        !infoBill.cfdi ||
        !infoBill.business_name ||
        !infoBill.rfc ||
        !infoBill.cfdi)
    ) {
      setMessage({
        status: true,
        message: "Los campos de facturación son requeridos",
        label: "error",
      });
      return;
    }

    if (infoPayment.method_payment === "Transferencia" && metodoPago === 'transfer') {
      if (
        infoPayment.folio_transfer === "" ||
        infoPayment.transfer_date === "" ||
        infoPayment.evidence === ""
      ) {
        setMessage({
          status: true,
          message: "Los campos de transferencia son requeridos",
          label: "error",
        });
        return;
      }
    }

    if (infoPayment.email_student === "" || !infoPayment.email_student) {
      setMessage({
        status: true,
        message: "El correo electrónico es requerido",
        label: "error",
      });
      return;
    }

    setMessage({
      status: true,
      message: "Guardando...",
      label: "info",
    });

    infoPayment["info_bill"] = infoBill;

    if(metodoPago === 'online'){
      PaymentMercadoPago();
      return;
    }

    const route = "PaymentFourMonth";
    let send = "";
    if (action === "pagar") {
      send = await insertDataJson(route, infoPayment);
    } else if(action === "reenviar"){
      send = await updateItem(
        `UpdatePaymentTransfer/${infoPayment.payment_four_month_id}`,
        infoPayment
      );
    }
    else{
      send = await updateItem(
        `${route}/${infoPayment.info_bill.payment_four_month_id}`,
        infoPayment
      );
    }

    if (send.code === 201 || send.code === 200) {
      setMessage({
        status: true,
        message: "Se ha guardado correctamente",
        label: "success",
      });
      setInfoReceipt(send.data);
      setIsPaidStatus(true);
      refreshList(infoPayment.year);
      setInfoBill({
        business_name: "",
        rfc: "",
        cfdi: "",
        bill: "",
      });
      return;
    }
    if (send.code === 400) {
      setMessage({
        status: true,
        message: "Ya se ha registrado este pago",
        label: "error",
      });
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, vuelva a seleccionar el mes",
      label: "error",
    });
  };

  const downloadEvidence = (evidence, code, description) => {
    var a = document.createElement("a");
    a.href = evidence;
    a.download = `${code}_${studentData.name}_${description}`;
    a.click();
  };

  const inputStyle = {
    width: '100%', padding: '7px 10px', border: '1px solid #d1d5db',
    borderRadius: '6px', fontSize: '0.82rem', backgroundColor: '#fff',
    outline: 'none', transition: 'border-color 0.15s, box-shadow 0.15s',
  };
  const inputFocus = (e) => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 3px rgba(220,38,38,0.1)'; };
  const inputBlur = (e) => { e.target.style.borderColor = '#d1d5db'; e.target.style.boxShadow = 'none'; };

  const fieldRow = (label, children) => (
    <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
      <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</span>
      <div>{children}</div>
    </div>
  );

  const total = infoPayment.amount
    ? ((parseFloat(infoPayment.amount) + parseFloat(infoPayment.surcharge === "" ? 0 : parseFloat(infoPayment.surcharge))) - (infoPayment.discount === "" ? 0 : parseFloat(infoPayment.discount))).toFixed(2)
    : "";

  return (
    <div style={{ padding: '8px 0 8px 16px' }}>
      {/* Panel header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px' }}>
          <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Detalle del Pago</span>
          {infoPayment.method_payment && (
            <div style={{ marginTop: '2px' }}>
              <span style={{ fontSize: '0.68rem', backgroundColor: '#f1f5f9', color: '#374151', padding: '1px 7px', borderRadius: '4px', fontWeight: 600 }}>
                {infoPayment.method_payment}
              </span>
            </div>
          )}
        </div>
        {infoPayment.evidence !== "" && (
          <a href="#" onClick={() => downloadEvidence(infoPayment.evidence, infoPayment.code, infoPayment.description)} target="_blank">
            <button style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 10px', border: '1px solid #d1fae5', borderRadius: '6px', backgroundColor: '#f0fdf4', color: '#166534', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer' }}>
              <i className="fa-solid fa-file-arrow-down"></i> Comprobante
            </button>
          </a>
        )}
      </div>

      {/* Concepto info card */}
      <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '14px 16px', marginBottom: '16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 16px', marginBottom: '10px' }}>
          {infoPayment.description && (
            <div>
              <span style={{ fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Descripción</span>
              <div style={{ fontSize: '0.82rem', fontWeight: 700, color: '#111827' }}>{infoPayment.description}</div>
            </div>
          )}
          {infoPayment.year > 0 && (
            <div>
              <span style={{ fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Año</span>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#374151' }}>{infoPayment.year}</div>
            </div>
          )}
          {infoPayment.four_month && (
            <div>
              <span style={{ fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Cuatrimestre</span>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#374151' }}>{infoPayment.four_month}</div>
            </div>
          )}
          {infoPayment.month && (
            <div>
              <span style={{ fontSize: '0.65rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Mes</span>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#374151' }}>{infoPayment.month}</div>
            </div>
          )}
        </div>

        {/* Inputs */}
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '10px' }}>
          {fieldRow("Importe",
            <input
              style={inputStyle} name="amount" value={infoPayment.amount}
              onChange={(e) => setInfoPayment({ ...infoPayment, [e.target.name]: e.target.value })}
              onFocus={inputFocus} onBlur={inputBlur}
            />
          )}

          {(infoPayment.paid_status === "surchargePaid" || infoPayment.paid_status === "surcharge") &&
            fieldRow("Recargo",
              <input
                type="number" min="0" style={inputStyle} name="surcharge" value={infoPayment.surcharge}
                onChange={(e) => setInfoPayment({ ...infoPayment, [e.target.name]: e.target.value })}
                onFocus={inputFocus} onBlur={inputBlur}
              />
            )
          }

          {infoPayment.numberOfDays && parseInt(infoPayment.numberOfDays) !== 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', padding: '6px 10px', backgroundColor: '#fef2f2', borderRadius: '6px', border: '1px solid #fecaca' }}>
              <i className="fa-solid fa-circle-exclamation" style={{ color: '#dc2626', fontSize: '12px' }}></i>
              <span style={{ fontSize: '0.72rem', color: '#dc2626', fontWeight: 600 }}>
                Día límite: {infoPayment.payday_limit} · {infoPayment.numberOfDays} días de atraso
              </span>
            </div>
          )}

          {fieldRow("Descuento",
            <input
              type="number" min="0" style={inputStyle} name="discount" value={infoPayment.discount}
              onChange={(e) => setInfoPayment({ ...infoPayment, [e.target.name]: e.target.value })}
              onFocus={inputFocus} onBlur={inputBlur}
            />
          )}
        </div>

        {/* Total */}
        {total && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px', padding: '10px 14px', backgroundColor: '#111827', borderRadius: '7px' }}>
            <span style={{ fontSize: '0.72rem', color: '#9ca3af', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Total</span>
            <span style={{ fontSize: '1.3rem', fontWeight: 800, color: '#fff', letterSpacing: '-0.02em' }}>${total}</span>
          </div>
        )}
      </div>

      {/* Método de pago (solo student) */}
      {userData.abbreviation === "student" && (
        <div style={{ marginBottom: '16px' }}>
          <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '8px' }}>¿Cómo desea pagar?</div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => { setMetodoPago('transfer'); setInfoPayment({ ...infoPayment, method_payment: "Transferencia" }); }}
              style={{
                padding: '7px 18px', borderRadius: '6px', fontSize: '0.78rem', fontWeight: 700, border: 'none', cursor: 'pointer',
                backgroundColor: metodoPago === 'transfer' ? '#111827' : '#f1f5f9',
                color: metodoPago === 'transfer' ? '#fff' : '#6b7280',
                transition: 'all 0.15s',
              }}
            >Transferencia</button>
          </div>
          {metodoPago === 'transfer'
            ? <PaymentTransfer setInfoPayment={setInfoPayment} infoPayment={infoPayment} handleFile={handleFile} />
            : <MercadoPagoButton onClick={() => savePaymentStudent("pagar")} />
          }
        </div>
      )}

      {/* Facturación */}
      {isBilled && (
        <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '14px 16px', marginBottom: '16px' }}>
          <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '10px' }}>Facturación</div>
          {fieldRow("Razón social", <input name="business_name" value={infoBill.business_name ?? ""} onChange={setState} style={inputStyle} onFocus={inputFocus} onBlur={inputBlur} />)}
          {fieldRow("RFC", <input name="rfc" value={infoBill.rfc ?? ""} onChange={setState} style={inputStyle} onFocus={inputFocus} onBlur={inputBlur} />)}
          {fieldRow("Uso CFDI", <input name="cfdi" value={infoBill.cfdi ?? ""} onChange={setState} style={inputStyle} onFocus={inputFocus} onBlur={inputBlur} />)}
          {(infoPayment.you_can_pay === "true" || infoPayment.you_can_pay === "false") &&
            (!infoPayment.info_bill.bill === "" || (!infoPayment.info_bill.bill && isPaidStatus)) && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <button onClick={() => savePaymentStudent("facturar")} style={{ padding: '8px 20px', backgroundColor: '#111827', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer' }}>
                  FACTURAR
                </button>
              </div>
            )
          }
        </div>
      )}

      {/* Alert */}
      {message.status && <Alert className="mb-4" severity={message.label}>{message.message}</Alert>}

      {/* Email */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '5px' }}>
          Correo del alumno
        </label>
        <input
          type="email" name="email_student"
          value={infoPayment.email_student ?? ""}
          onChange={(e) => setInfoPayment({ ...infoPayment, [e.target.name]: e.target.value })}
          style={inputStyle} onFocus={inputFocus} onBlur={inputBlur}
          placeholder="correo@ejemplo.com"
        />
      </div>

      {/* Action buttons */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', paddingTop: '8px' }}>
        {infoPayment?.type === 'procedure' && isPaidStatus && (
          <PDFDownloadLink
            document={<PDFReceipt name={studentData.name ?? ""} curp={studentData.curp ?? ""} career={studentData.career_name ?? ""} item={infoReceipt} description={infoPayment.description} />}
            fileName={`Recibo_${infoPayment.description}_${infoPayment.year}`}
          >
            <button style={{ padding: '9px 20px', backgroundColor: '#16a34a', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer' }}>
              <i className="fa-solid fa-file-arrow-down" style={{ marginRight: '6px' }}></i>Descargar Recibo
            </button>
          </PDFDownloadLink>
        )}

        {(infoPayment.you_can_pay === "true" || infoPayment.you_can_pay === "false") && (
          isPaidStatus ? (
            parseInt(infoPayment.status) === 2 ? (
              <button onClick={() => savePaymentStudent("reenviar")} style={{ padding: '9px 20px', backgroundColor: '#111827', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer' }}>
                <i className="fa-solid fa-paper-plane" style={{ marginRight: '6px' }}></i>REENVIAR COMPROBANTE
              </button>
            ) : (
              <button style={{ padding: '9px 20px', backgroundColor: '#15803d', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '0.78rem', fontWeight: 700, cursor: 'default' }}>
                <i className="fa-solid fa-check" style={{ marginRight: '6px' }}></i>
                {!infoPayment.info_bill && infoPayment.info_bill.bill !== null && infoPayment.info_bill.bill !== "" ? "PAGADO Y FACTURADO" : "PAGADO"}
              </button>
            )
          ) : (
            metodoPago === 'transfer' && (
              <button onClick={() => savePaymentStudent("pagar")} style={{ padding: '9px 28px', backgroundColor: '#111827', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer', letterSpacing: '0.04em' }}>
                PAGAR
              </button>
            )
          )
        )}
      </div>
    </div>
  );
};

export default PaymentCashModule;
